import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function HollywoodProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Hollywood"
      introText="Hollywood travelers have several options. Here's how they compare — and why most choose a U.S. Department of State registered passport courier agency to handle their passport."
      options={options}
      emergencyDescription="Miami is only ~20 miles — but the distance is deceptive. I-95 traffic through Broward County turns 20 miles into 1+ hours during any daylight hour. Snowbird season (Nov–April) doubles demand across Broward — 2M+ residents plus seasonal influx overwhelming Miami's single agency. Port Everglades cruise passengers on same-day departure can't afford a single breakdown on I-95. Hollywood Beach international tourists discovering expired passports mid-vacation face Florida's single agency serving 22M+ statewide."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}